var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#New_Gradient_Swatch_2);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-width: 0px;\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: #fefcf2;\n      }\n\n      .cls-8 {\n        fill: #6c9;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 406.26,
    y: 211.21,
    width: 424.35,
    height: 657.34
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    "data-name": "New Gradient Swatch 2",
    x1: 192.88,
    y1: 140.56,
    x2: 547.15,
    y2: 872.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8ad42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f49120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ef5a26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ed5929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#d6565b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#c5547e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ba5294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7529d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2681.04,
    y1: -4030.2,
    x2: -2283.36,
    y2: -4474.76,
    gradientTransform: "translate(-1744.01 -3816.77) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#663398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3366cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#458ab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#56ada7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#61c39c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2340.61,
    y1: -4527.19,
    x2: -2157.94,
    y2: -4216.8,
    gradientTransform: "translate(-1744.01 -3816.77) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#73c4a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#71c4a0",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#6fc69e",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#6ac99b",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 492.26,
    y1: 870.88,
    x2: 662.52,
    y2: 479.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#73c4a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#6bc89c",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#6c9",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M406.26,396.44c1.56-28.04,22.15-59.58,47.12-71.37l206.2-97.46c94.07-44.46,171.04,4.63,171.04,109.1v329.6c0,33-24.32,71.5-54.04,85.54l-215.48,101.84c-83.4,39.42-151.94-2.35-154.84-92.84v-364.41Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M624.03,357.38c-1.88-30.27-26.56-64.31-56.48-77.05l-247.2-105.21c-112.78-48-205.05,5-205.05,117.78v355.83c0,35.63,29.15,77.19,64.78,92.35l258.33,109.95c99.98,42.55,182.16-2.53,185.63-100.23v-393.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M623.77,361.04v383.29c0,76.54-46.92,122.68-113.42,122.73,22.26.02,46.71-5.13,72.34-16.03l258.33-109.95c35.63-15.16,64.78-56.72,64.78-92.35v-355.83c0-112.78-92.27-165.78-205.05-117.78l-190.39,81.03,56.81,24.18c31.14,13.25,56.61,49.57,56.61,80.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M396.93,361.31v383.29c0,76.54,46.92,122.68,113.42,122.73,66.5-.05,113.42-46.19,113.42-122.73v-383.29c0-31.14-25.48-67.46-56.61-80.71l-56.81-24.18-56.81,24.18c-31.14,13.25-56.61,49.57-56.61,80.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M700.47,174.99l-190.39,81.03.27.27-56.81,24.18c-31.14,13.25-56.61,49.57-56.61,80.71v383.29c0,76.54,46.92,122.68,113.42,122.73,8.68,0,17.02-.82,24.97-2.36,15.05-2.43,30.84-7.03,47.09-13.94l258.33-109.95c35.63-15.16,64.78-56.72,64.78-92.35v-355.83c0-112.78-92.27-165.78-205.05-117.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M195.21,435.22h29.25l55.46,67.49v-48.42.02c0-7.41,6.77-19.09,20.49-19.09h14.33v126.65h-29.25l-55.46-67.49v48.41-.02c0,7.35-6.77,19.1-20.49,19.1h-14.33v-126.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M329.46,433.67c0-5.18,1.92-9.53,5.75-13.02,3.83-3.49,8.86-5.24,15.08-5.24s11.25,1.66,15.07,4.97c3.82,3.32,5.74,7.58,5.74,12.76s-1.91,9.92-5.74,13.48c-3.83,3.56-8.85,5.33-15.07,5.33s-11.25-1.75-15.08-5.24c-3.83-3.5-5.75-7.84-5.75-13.04ZM333.24,481.91c0-7.62,6.76-19.09,20.48-19.09h13.61v98.07h-34.1v-79,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M376.33,462.82h19.38c13.87,0,17.05,3.58,23.18,18.94l16.32,40.94,24.05-59.89h32.48l-42,102.05c-4.9,12.07-10.89,20.54-17.94,25.42-7.06,4.89-15.67,7.33-25.84,7.33-5.14,0-10.32-.81-15.52-2.44-5.2-1.63-9.42-3.77-12.65-6.42l11.84-24.07c1.91,1.81,4.22,3.22,6.91,4.25,2.69,1.02,5.41,1.54,8.16,1.54,3.24,0,5.9-.66,7.99-1.99s3.86-3.44,5.29-6.34l-41.63-99.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M491.77,462.82h19.38c13.87,0,17.05,3.58,23.18,18.94l16.32,40.94,24.05-59.89h32.48l-42,102.05c-4.9,12.07-10.89,20.54-17.94,25.42-7.06,4.89-15.67,7.33-25.84,7.33-5.14,0-10.32-.81-15.52-2.44-5.2-1.63-9.42-3.77-12.65-6.42l11.84-24.07c1.91,1.81,4.22,3.22,6.91,4.25,2.69,1.02,5.41,1.54,8.16,1.54,3.24,0,5.9-.66,7.99-1.99s3.86-3.44,5.29-6.34l-41.63-99.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M627.34,558.54c-5.5-2.65-9.66-6.24-12.47-10.77-2.81-4.52-4.22-9.68-4.22-15.47,0-9.3,3.53-16.5,10.59-21.64,7.06-5.13,17.94-7.69,32.67-7.69h19.38c-.6-10.37-7.48-15.55-20.64-15.55-4.66,0-9.39.75-14.17,2.26-4.79,1.51-8.86,3.59-12.21,6.24l-11.49-23.34c5.38-3.61,11.93-6.42,19.65-8.39,7.72-1.99,15.46-2.99,23.25-2.99,16.15,0,28.47,3.71,36.97,11.13,8.49,7.42,12.74,18.79,12.74,34.11v54.46h-11.28c-13.71,0-20.48-11.74-20.48-19.09v.02s0-20.92,0-20.92h-17.04c-9.93,0-14.89,3.32-14.89,9.95,0,3.02,1.13,5.42,3.41,7.24,2.27,1.81,5.38,2.71,9.34,2.71,3.37,0,9.32-1.33,11.84-3.82,1.69,3.1,2.45,7.47,2.31,10.36-.4,8.82-6.68,12.76-13.45,14.19-3.09.65-6.49.98-10.21.98-7.54,0-14.07-1.32-19.57-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M743.67,560.88c-13.71,0-20.48-11.82-20.48-19.1v-115.16h34.1v61.07c1.63-15.07,11.67-26.51,29.25-26.51,12.08,0,21.81,3.62,29.16,10.86,7.36,7.24,11.04,18.15,11.04,32.75v56.09h-34.1v-50.48c0-13.39-5.32-20.09-15.97-20.09-5.86,0-10.56,1.93-14.09,5.79-3.53,3.86-5.29,9.66-5.29,17.38v47.4h-13.62Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1a941c15cfe6b7fa4849d9f8d472e12c.svg";
export { ForwardRef as ReactComponent };